export function contentDisplayName(entity: {
  name?: string;
  localizedName?: string | null;
}): string {
  const localized = entity?.localizedName?.trim();
  return localized || entity?.name || "";
}
